/**
 * 职位数据转换工具
 * 前台和后台共用的 postedAt → postedDate 转换逻辑
 */
import dayjs from 'dayjs';

/**
 * 将相对时间字符串转换为 Date 对象
 * 例如：'1 day ago' → 1天前的日期
 *       'Today' → 今天的日期
 *       '3 days ago' → 3天前的日期
 */
export const convertPostedAtToDate = (postedAt: string): Date => {
  const now = dayjs();

  if (postedAt === 'Today') {
    return now.toDate();
  }

  const match = postedAt.match(/(\d+)\s*(hour|hours|day|days|week|weeks)\s+ago/);
  if (match) {
    const value = parseInt(match[1]);
    const unit = match[2];

    if (unit.includes('hour')) {
      return now.subtract(value, 'hour').toDate();
    } else if (unit.includes('day')) {
      return now.subtract(value, 'day').toDate();
    } else if (unit.includes('week')) {
      return now.subtract(value, 'week').toDate();
    }
  }

  return now.toDate();
};
